import { useRouter } from "next/router";

import Image                         from "_components/atoms/image";
import VideoPlayer                   from "_components/features/player";
import { useGetCanWatchMoreContent } from "_jotai/compulsoryLogin";

import useStyles from "./styles";

function VideoContainer ( { reel, fadeReelControls, isReelReported } ) {

	const { classes }         = useStyles ();
	const router              = useRouter ();
	const canWatchMoreContent = useGetCanWatchMoreContent ();

	const reelSrc       = reel.media.find ( item => item.mediaSequence === "3" )?.href;
	const reelThumbnail = reel.media.find ( item => item.mediaSequence === "7" )?.href;

	return (
		<div
			className = { classes.videoRoot }
			onClick   = { e => e.stopPropagation () }
		>
			{
				router.query.id === reel.id && canWatchMoreContent ? (
					<VideoPlayer
						key                = { reel.id }
						blockInternalClick = { true }
						fadeReelControls   = { fadeReelControls }
						isReel             = { true }
						loop               = { true }
						src                = { reelSrc }
						thumbnail          = { reelThumbnail }
					/>
				) : (
					<Image
						alt         = { "reel-thumbnail" }
						className   = { classes.reelThumbnail }
						placeholder = "/images/rectangle-placeholder.webp"
						src         = { reelThumbnail }
					/>
				)
			}
		</div>
	);
}

/* function ReportedReelDrawer ( { isReelReported } ) {
  const { classes } = useStyles ();

  return (
    <Show visible = { isReelReported }>
      <Drawer
        className = { {
          content: classes.drawerContent
        } }
        onClose = { () => {} }
        opened = { true }
        position = { "bottom" }
        withCloseButton = { false }
      >
        <div className = { classes.drawerWrapper }>

          <Icon className = { classes.tickIcon }
            name = { "tickFilled" }
          />

          <Typography title = { "Reported Successfully" } />

          <Typography title = { "Our community team will look into this." } />
        </div>

      </Drawer>
    </Show>
  );
} */
export default VideoContainer;
